// @flow
import * as React from 'react'

type Props = {
  title: string,
  children: React.Node,
}

function ClientDemographicsTableContent({
  title,
  children,
}: Props): React.Node {
  return (
    <>
      <div className="border-b border-t bg-gray-50 bg-light-40 px-2 py-2">
        <div className="text-xl font-semibold">{title}</div>
      </div>
      <div className="mb-4 px-4 py-2">{children}</div>
    </>
  )
}

export default ClientDemographicsTableContent
